const isObject = object => Object.prototype.toString.call(object) === '[object Object]';

const recursion = (object, newObj = { children: [] }) => {
  for (const key of Object.keys(object)) {
    if (isObject(object[key])) {
      const tempObj = {
        // text: key,
        children: [],
      };
      recursion(object[key], tempObj);
      newObj.children.push(tempObj);
    } else if (key === 'name') {
      // eslint-disable-next-line
      newObj['label'] = object['name'];
    } else if (key !== undefined) {
      // eslint-disable-next-line
      newObj[key] = object[key];
    }
  }
};

const objToTree = (arr) => {
  if (arr.length) {
    const treeArr = [];
    arr.forEach((item) => {
      const tempObj = {
        children: [],
      };
      recursion(item, tempObj);
      treeArr.push(tempObj);
    });
    return treeArr;
  }
  return [];
};

/**
 * 构建DB，由树状结构的root下的children开始
 * @param arr
 */
const buildDB = (arr = []) => {
  let ret = {};
  arr.forEach((item) => {
    if (item.id) {
      // console.l''og('发现有id的item=', item);

      const itemTarget = {};

      for (const key in item) {

        if (key === 'children') {
          ret = { ...ret, ...buildDB(item.children) };
        } else {
          itemTarget[key] = item[key];
        }
      }
      // console.log(item.id,typeof item.id);
      ret[item.id] = itemTarget;
    } else {
      // 没有ID，则是一个空节点，直接遍历其children
      ret = { ...ret, ...buildDB(item.children) };
    }
  });

  return ret;
};


export {
  objToTree,
  buildDB,
};



// WEBPACK FOOTER //
// ./src/utils/utilFun.js